import { createContext } from 'react';

const FormWorkflowContext = createContext();
export default FormWorkflowContext;
